import { createContext, useContext } from "react";
import { TabNavItemDetails } from "./TabNav.types";

interface TabsNavHelper {
  addTab: (details: TabNavItemDetails) => void;
  closeTab: (id: string) => void;
}
export const TabsNavContext = createContext<TabsNavHelper>({} as TabsNavHelper);
export const useTabsNavContext = () => useContext(TabsNavContext);
